export default __webpack_public_path__ + "static/media/data-collector-site.f2b79f78.svg";